import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useIsFeatureEnabled } from "../_app/featureFlags";
import { CreateOfferPage } from "../createOffer/CreateOfferPage";

export const Route = createFileRoute("/angebot-erstellen")({
  component: CreateOfferRoute,
});

function CreateOfferRoute() {
  const isCreateOfferEnabled = useIsFeatureEnabled("createOffer");

  if (!isCreateOfferEnabled) {
    return <Navigate to="/" />;
  }

  return <CreateOfferPage />;
}
